var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.33203 8.64732V4.66065C1.33203 2.82065 2.82536 1.33398 4.66536 1.33398H11.332C13.172 1.33398 14.6654 2.82065 14.6654 4.66065V9.31398C14.6654 11.1473 13.172 12.634 11.332 12.634H10.332C10.1254 12.634 9.92536 12.734 9.7987 12.9007L8.7987 14.2273C8.3587 14.814 7.6387 14.814 7.1987 14.2273L6.1987 12.9007C6.09203 12.754 5.85203 12.634 5.66536 12.634H4.66536C2.82536 12.634 1.33203 11.1473 1.33203 9.31398V8.64732Z",
    fill: "#009B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 7.99935C7.62536 7.99935 7.33203 7.69935 7.33203 7.33268C7.33203 6.96602 7.63203 6.66602 7.9987 6.66602C8.36536 6.66602 8.66536 6.96602 8.66536 7.33268C8.66536 7.69935 8.37203 7.99935 7.9987 7.99935Z",
    fill: "#009B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.99935C10.2933 7.99935 10 7.69935 10 7.33268C10 6.96602 10.3 6.66602 10.6667 6.66602C11.0333 6.66602 11.3333 6.96602 11.3333 7.33268C11.3333 7.69935 11.04 7.99935 10.6667 7.99935Z",
    fill: "#009B62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33464 7.99935C4.9613 7.99935 4.66797 7.69935 4.66797 7.33268C4.66797 6.96602 4.96797 6.66602 5.33464 6.66602C5.7013 6.66602 6.0013 6.96602 6.0013 7.33268C6.0013 7.69935 5.70797 7.99935 5.33464 7.99935Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.32fdd9a54124897724903e9d3c7acd5b.svg";
export { ForwardRef as ReactComponent };